'use strict';

module.exports = require('./Slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.4.3@rc-slider/lib/index.js
 ** module id = 543
 ** module chunks = 0
 **/